const textarea = require('../textarea/textarea');

// SVG component: extends textarea with a file browser and a live preview.
// The user selects an .svg file; its text contents are read client-side and stored
// as the component value in the hidden textarea, then rendered in the preview div.
const svg = Object.assign({}, textarea, {
    subelements: {
        fileInput: null,
        preview: null,
        validationMessage: null
    },

    

    init: function () {
        textarea.init.call(this);

        // Resize the initial preview on page load (handles both pre-loaded values and configured dimensions).
        if (this.subelements.preview) {
            setTimeout(() => { this.resizeSvgPreview(); }, 0);
        }

        // Update the preview whenever the user edits the SVG code directly in the textarea.
        this.element.addEventListener('input', () => { this.updatePreview(); });

        // When the user selects an .svg file, read its text contents client-side,
        // load them into the textarea, update the preview, then clear the file input
        // so another file can be loaded without needing to clear it manually.
        if (this.subelements.fileInput) {
            this.subelements.fileInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (!file) {
                    return;
                }

                const reader = new FileReader();
                reader.onload = (evt) => {
                    this.element.value = evt.target.result;
                    this.updatePreview();
                    this.subelements.fileInput.value = '';
                };
                reader.readAsText(file);
            });
        }
    },

    // Set the <svg> element's width and height on the preview.
    // If explicit dimensions are configured via data-zit-svg-width / data-zit-svg-height those are
    // used; otherwise the preview container width and the textarea height are used as fallbacks.
    resizeSvgPreview: function () {
        const svgEl = this.subelements.preview.querySelector('svg');
        if (!svgEl) {
            return;
        }

        const configuredWidth = this.subelements.preview.dataset.zitSvgWidth;
        const configuredHeight = this.subelements.preview.dataset.zitSvgHeight;

        const w = configuredWidth || this.subelements.preview.clientWidth;
        const h = configuredHeight || this.element.offsetHeight;

        if (w) {
            svgEl.setAttribute('width', w);
        }
        if (h) {
            svgEl.setAttribute('height', h);
        }
    },

    // Update the preview div from the current textarea value and resize the svg element.
    updatePreview: function () {
        if (this.subelements.preview) {
            this.subelements.preview.innerHTML = this.element.value;
            this.resizeSvgPreview();
        }
    }
});

module.exports = svg;
